
const sidebar = () => {


	const sidebar = document.querySelector('.layout-sidebar');
	const toggles = document.querySelectorAll('.layout-sidebar-toggle-btn');



	for (let i = 0; i < toggles.length; i++) {
	    toggles[i].addEventListener('click', function() {
	        sidebar.classList.toggle('open');
	    });
	}


}

export { sidebar }